























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import ActivateStamp from "./activate-stamp.vue";
import ViewCollectionCode from "./view-info.vue";

class PageCollectionCodeRequest extends PageRequest {
  mainSerialNo: string;
  hiddenCode: string;
}

@Component({
  components: {
    "activate-stamp": ActivateStamp,
    "view-collectionCode": ViewCollectionCode,
  },
})
export default class CollectionCodeProduct extends mixins(ListMixin, AbpBase) {
  namespace = "collectionCodeProduct";
  statuses = [];
  viewModalShow: boolean = false;
  activateModalShow: boolean = false;
  selectedMainSerialNo = "";
  selectedSku = "";
  selectedProductName = "";
  spinShow = false;
  pagerequest: PageCollectionCodeRequest = new PageCollectionCodeRequest();
  get store() {
    return this.$store.state.collectionCodeProduct;
  }
  get items() {
    return this.store.items;
  }
  checkFilterCriteria() {
    if (
      _.isNil(this.pagerequest.mainSerialNo) &&
      _.isEmpty(this.pagerequest.mainSerialNo) &&
      _.isNil(this.pagerequest.hiddenCode) &&
      _.isEmpty(this.pagerequest.hiddenCode)
    ) {
      Util.showErrorMsg(this, "Error.RequireFilterCriteria");
      return false;
    }
    if (
      (!_.isNil(this.pagerequest.mainSerialNo) &&
        !_.isEmpty(this.pagerequest.mainSerialNo) &&
        this.pagerequest.mainSerialNo.length < 8) ||
      (!_.isNil(this.pagerequest.hiddenCode) &&
        !_.isEmpty(this.pagerequest.hiddenCode) &&
        this.pagerequest.hiddenCode.length < 8)
    ) {
      Util.showErrorMsg(
        this,
        Util.L(
          "Error.InvalidObject",
          undefined,
          `${Util.L("MainSerialNo")}/${Util.L("HiddenCode")}`
        )
      );
      return false;
    }
    return true;
  }
  async getpage() {
    if (this.checkFilterCriteria()) {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = this.currentPage;
      this.preGetPage();
      await this.$store
        .dispatch({
          type: `${this.namespace}/getAll`,
          data: this.pagerequest,
        })
        .finally(() => {
          this.store.loading = false;
        });
    }
  }

  deactivateStamp(row) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.DeactivateStamp"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: `${this.namespace}/stampDeactivate`,
            data: {
              mainSerialNo: row.mainSerialNo,
            },
          })
          .then(() => {
            Util.showSuccessMsg(this, "Success.DeactivateStamp");
            this.getpage();
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  activateStamp(row: any) {
    this.activateModalShow = true;
    this.selectedMainSerialNo = row.mainSerialNo;
    this.selectedSku = row.sku;
    this.selectedProductName = row.productName;
  }
  viewInfo(row: any) {
    this.viewModalShow = true;
    this.selectedMainSerialNo = row.mainSerialNo;
  }

  columns = [
    {
      title: Util.L("MainSerialNo"),
      width: 150,
      slot: "mainSerialNo",
    },
    {
      title: Util.L("SubSerialNo"),
      width: 150,
      key: "subSerialNo",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "productName",
    },
    {
      title: Util.L("Category"),
      width: 100,
      key: "categoryName",
    },
    {
      title: Util.L("BrandName"),
      width: 100,
      key: "brandName",
    },
    {
      title: Util.L("ExportBrandName"),
      width: 120,
      key: "exportBrandName",
    },
    {
      title: Util.L("Status"),
      width: 150,
      key: "statusName",
    },
    {
      title: Util.L("OutboundDate"),
      key: "outboundDate",
      width: 100,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.outboundDate)) return "";
        return h("span", Util.toViewDatePickerString(params.row.outboundDate));
      },
    },
    {
      title: Util.L("ManufactureMonth"),
      key: "manufactureMonth",
      width: 100,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.manufactureMonth)) return "";
        return h("span", Util.toMonthYearString(params.row.manufactureMonth));
      },
    },
    {
      title: Util.L("DistributorOutboundDate"),
      key: "distributorOutboundDate",
      width: 100,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.distributorOutboundDate)) return "";
        return h(
          "span",
          Util.toViewDatePickerString(params.row.distributorOutboundDate)
        );
      },
    },
    {
      title: Util.L("Action"),
      width: 100,
      align: "center",
      slot: "action",
    },
  ];
  async created() {}
}
